/**
 * Extracts the filename from a Google Cloud Storage URL
 * @param url - The GCS URL (e.g., "https://storage.googleapis.com/bucket-name/file.pdf?signature=...")
 * @returns The decoded filename, or 'downloaded_file' if extraction fails
 */
const getGcsURLFilename = (url: string): string => {
  try {
    const parsed = new URL(url);

    // Split the pathname into segments and filter out empty segments
    // Example pathname: "/bucket-name/some%20file.pdf"
    const pathSegments = parsed.pathname.split('/').filter((segment) => segment.length > 0);

    // Filename is always the last segment after the bucket
    // Return default filename if no path segments are found
    if (pathSegments.length === 0) {
      return 'downloaded_file';
    }

    const rawFilename = pathSegments[pathSegments.length - 1];

    // Decode URL-encoded characters (e.g., %20 -> space)
    return decodeURIComponent(rawFilename);
  } catch (err) {
    console.error('Failed to get filename from GCS URL', err);
    return 'downloaded_file';
  }
};

export default getGcsURLFilename;
